export default function TextareaInput({ question, value, onChange, error }) {
  const charCount = (value || "").length;
  const maxLength = question.validation?.maxLength;

  return (
    <div className="flex flex-col gap-2">
      <textarea
        value={value || ""}
        onChange={(e) => {
          let next = e.target.value;
          if (question.filter) next = question.filter(next);
          onChange(question.id, next);
        }}
        placeholder={question.placeholder || "Ketik jawaban Anda di sini..."}
        rows={4}
        className={`w-full px-5 py-3.5 rounded-xl bg-white/5 border text-white placeholder-white/40
          font-sans text-sm desktop:text-base outline-none transition-all duration-300
          focus:bg-white/10 focus:ring-2 focus:ring-white/20 resize-none
          ${error ? "border-red" : "border-white/20 focus:border-white/40"}`}
      />
      {maxLength && (
        <p
          className={`text-xs font-sans text-right transition-colors duration-300
            ${charCount > maxLength ? "text-red" : "text-white/30"}`}
        >
          {charCount}/{maxLength}
        </p>
      )}
    </div>
  );
}
